var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"type":"primary"},on:{"click":_vm.goToLoanRoute}},[_vm._v("\n  "+_vm._s(_vm.$t('apply_for_loan'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }